<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">
        Lista de Arquivos Integrados
      </p>
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Unidade:
          <q-select
            class="input-new-design"
            dense
            outlined
            v-model="filtros.unidadeId"
            :options="unidadeOptions"
            option-value="id"
            option-label="nome"
            emit-value
            map-options
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Código Integração:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.codigoIntegracao"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Nome do Arquivo:
          <q-input
            class="input-new-design"
            dense
            outlined
            v-model="filtros.nomeArquivo"
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Status:
          <q-select
            class="input-new-design"
            dense
            outlined
            v-model="filtros.status"
            :options="statusOptions"
            option-value="value"
            option-label="label"
            emit-value
            map-options
          />
        </div>
      </div>

      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Data Inicial:
          <q-input
            dense
            class="input-new-design"
            outlined
            v-model="filtros.dataInicial"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataInicial"
                    :options="optionsDataInicial"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 q-ml-sm">
          Data Final:
          <q-input
            dense
            class="input-new-design"
            outlined
            v-model="filtros.dataFinal"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                    :options="optionsDataFinal"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-2 q-ml-sm">
          Número de Linhas:
          <q-input
            class="input-new-design"
            dense
            outlined
            type="number"
            v-model="filtros.perPage"
            min="1"
            max="100"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="id"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Total de Arquivos: {{ totalArquivos }}</span
          >
        </template>
        <template #body-cell-status="props">
          <q-td>
            <q-badge
              :color="getStatusColor(props.row.status)"
              :label="props.row.status"
            />
          </q-td>
        </template>
        <template #body-cell-data_geracao="props">
          <q-td>
            {{ formatarData(props.row.data_geracao) }}
          </q-td>
        </template>
        <template #body-cell-data_envio="props">
          <q-td>
            {{ formatarData(props.row.data_envio) }}
          </q-td>
        </template>
        <template #body-cell-link_arquivo="props">
          <q-td>
            <q-btn
              v-if="props.row.link_arquivo"
              style="margin-left: 15px"
              flat
              dense
              icon="download"
              color="primary"
              @click="downloadArquivo(props.row.link_arquivo)"
            />
            <q-tooltip>Baixar Arquivo</q-tooltip>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "unidade_nome",
    label: "Nome Unidade",
    field: "unidade_nome",
    align: "left",
  },
  {
    name: "codigo_integracao",
    label: "Código Integração",
    field: "codigo_integracao",
    align: "left",
  },
  {
    name: "nome_arquivo",
    label: "Nome Arquivo",
    field: "nome_arquivo",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
  },
  {
    name: "mensagem",
    label: "Mensagem",
    field: "mensagem",
    align: "left",
  },
  {
    name: "data_geracao",
    label: "Data Geração",
    field: "data_geracao",
    align: "left",
  },
  {
    name: "data_envio",
    label: "Data Envio",
    field: "data_envio",
    align: "left",
  },
  {
    name: "link_arquivo",
    label: "Download",
    field: "link_arquivo",
    align: "center",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";

export default {
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const filtros = ref({
      unidadeId: null,
      codigoIntegracao: "",
      nomeArquivo: "",
      status: null,
      dataInicial: "",
      dataFinal: "",
      perPage: 15,
    });
    const disable = ref(true);
    const totalArquivos = ref(0);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const unidadeOptions = ref([]);
    const statusOptions = ref([
      { label: "Sucesso", value: "sucesso" },
      { label: "Erro", value: "erro" },
      { label: "Gerado", value: "gerado" },
    ]);

    const configurarDataInicial = () => {
      const hoje = new Date();
      const quinzeDiasAtras = new Date(hoje);
      quinzeDiasAtras.setDate(hoje.getDate() - 15);

      const formatarDataInterface = (data) => {
        const dia = String(data.getDate()).padStart(2, "0");
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
      };

      filtros.value.dataInicial = formatarDataInterface(quinzeDiasAtras);
      filtros.value.dataFinal = formatarDataInterface(hoje);
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        unidadeOptions.value = [
          { id: null, nome: "TODOS" },
          ...response.listaUnidades,
        ];
      } catch (error) {
        console.error("Erro ao listar unidades:", error);
      }
    };

    const getDados = async (page = 1, rowsPerPage = 15) => {
      try {
        const converterDataParaAPI = (data) => {
          if (!data) return "";
          return data.replace(/\//g, "-");
        };

        let response = await store.dispatch(
          "integracao/getLogsArquivosBraskem",
          {
            codigo_integracao_empresa: await verifyValue(
              filtros.value.codigoIntegracao
            ),
            unidade_id: filtros.value.unidadeId,
            nome_arquivo: await verifyValue(filtros.value.nomeArquivo),
            status: filtros.value.status,
            data_inicial: await verifyValue(
              converterDataParaAPI(filtros.value.dataInicial)
            ),
            data_final: await verifyValue(
              converterDataParaAPI(filtros.value.dataFinal)
            ),
            page: page,
            per_page: rowsPerPage,
          }
        );

        let dados, total, currentPage;

        if (response.data?.result) {
          dados = response.data.result.data || response.data.result || [];
          total = response.data.result.total || 0;
          currentPage = response.data.result.current_page || page;
        } else if (response.data?.data) {
          dados = response.data.data || [];
          total = response.data.total || 0;
          currentPage = response.data.current_page || page;
        } else {
          dados = response.data || [];
          total = dados.length || 0;
          currentPage = page;
        }

        rows.value = Array.isArray(dados) ? dados : [];
        pagination.value.page = currentPage;
        pagination.value.rowsPerPage = rowsPerPage;
        pagination.value.rowsNumber = total;
        totalArquivos.value = total;
        disable.value = false;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        quasar.notify({
          message: "Erro ao procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const verifyValue = async (value) => {
      if (value != "") {
        return value;
      } else {
        return undefined;
      }
    };

    const formatarData = (data) => {
      if (!data) return "";
      const dataObj = new Date(data);
      if (isNaN(dataObj.getTime())) return data;
      return dataObj.toLocaleDateString("pt-BR");
    };

    const getStatusColor = (status) => {
      switch (status) {
        case "sucesso":
          return "positive";
        case "erro":
          return "negative";
        case "gerado":
          return "warning";
        default:
          return "grey";
      }
    };

    const downloadArquivo = (link) => {
      if (link) {
        window.open(link, "_blank");
      }
    };

    const optionsDataInicial = (date) => {
      const hoje = new Date();
      const dataAtual = hoje.toISOString().split("T")[0].replace(/-/g, "/");
      return date <= dataAtual;
    };

    const optionsDataFinal = (date) => {
      const hoje = new Date();
      const dataAtual = hoje.toISOString().split("T")[0].replace(/-/g, "/");
      return date <= dataAtual;
    };

    watchDebounced(
      [
        () => pagination.value.page,
        () => filtros.value.unidadeId,
        () => filtros.value.codigoIntegracao,
        () => filtros.value.nomeArquivo,
        () => filtros.value.status,
        () => filtros.value.dataInicial,
        () => filtros.value.dataFinal,
        () => filtros.value.perPage,
      ],
      () => {
        const validarData = (data) => {
          if (!data) return true;
          const regex = /^\d{2}\/\d{2}\/\d{4}$/;
          return regex.test(data);
        };

        if (
          filtros.value.dataInicial &&
          !validarData(filtros.value.dataInicial)
        ) {
          console.warn("Data inicial inválida:", filtros.value.dataInicial);
          return;
        }
        if (filtros.value.dataFinal && !validarData(filtros.value.dataFinal)) {
          console.warn("Data final inválida:", filtros.value.dataFinal);
          return;
        }

        if (filtros.value.perPage != pagination.value.rowsPerPage) {
          pagination.value.rowsPerPage = filtros.value.perPage;
          pagination.value.page = 1;
        }

        disable.value = true;
        handleRequest();
      },
      { debounce: 400 }
    );

    onMounted(() => {
      configurarDataInicial();
      listarUnidades();
      getDados();
    });

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      filtros,
      disable,
      totalArquivos,
      pagination,
      unidadeOptions,
      statusOptions,
      formatarData,
      getStatusColor,
      downloadArquivo,
      verifyValue,
      optionsDataInicial,
      optionsDataFinal,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}
</style>
